export interface ISocial {
  title: string;
  url: string;
  image: string;
}

export const mainSocials: ISocial[] = [
  {
    title: "Instagram",
    url: "https://www.instagram.com/sfamentertainment/",
    image: "instagram.svg",
  },
  {
    title: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61570925963018",
    image: "facebook3.svg",
  },
];
